module.exports = __webpack_public_path__ + "img/shell.1730396e.png";